import { BackendHttpService } from './backendHttpService';

export interface LanguageOption {
  id: number;
  englishName: string;
  nativeName: string;
}

export class LanguageService extends BackendHttpService {
  constructor() {
    super('Language');
  }

  /**
   * Get all available languages
   * @returns Promise with the language options
   */
  async getLanguages(): Promise<LanguageOption[]> {
    try {
      return await this.get<LanguageOption[]>('');
    } catch (error) {
      console.error('Error fetching languages:', error);
      throw error;
    }
  }
} 